import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const StaticEventsPage = () => {
  // Little League data
  const littleLeagueData = [
    { sno: 1, tournament: "1st Little League", date: "May 1995", winners: "U.P.", heldAt: "Dehradun" },
    { sno: 2, tournament: "2nd Little League", date: "May 1998", winners: "U.P.", heldAt: "Solan" },
    { sno: 3, tournament: "3rd Little League", date: "May 1999", winners: "M.P.", heldAt: "Solan" },
    { sno: 4, tournament: "4th Little League", date: "Oct 2002", winners: "Delhi", heldAt: "Solan" },
    { sno: 5, tournament: "5th Little League", date: "May 2003", winners: "Delhi", heldAt: "Solan" },
    { sno: 6, tournament: "6th Little League", date: "Nov 2004", winners: "Delhi", heldAt: "Dehradun" },
    { sno: 7, tournament: "7th Little League", date: "Jan 2006", winners: "Delhi", heldAt: "New Mumbai" },
    { sno: 8, tournament: "8th Little League", date: "Jan 2007", winners: "Delhi", heldAt: "Garhmuketeswar, Ghaziabad" },
    { sno: 9, tournament: "9th Little League", date: "Feb 2008", winners: "Delhi", heldAt: "Cuttack" },
    { sno: 10, tournament: "10th Little League", date: "Nov 2008", winners: "U. Khand", heldAt: "Dehradun" },
    { sno: 11, tournament: "11th Little League", date: "Nov 2009", winners: "Delhi", heldAt: "Garhmuketswar" },
    { sno: 12, tournament: "12th Little League Baseball", date: "Jan 2011", winners: "Delhi", heldAt: "Garhmuketswar" },
    { sno: 13, tournament: "13th Little League Baseball", date: "19-21 Sep 2014", winners: "Chandigarh", heldAt: "Dehradun" },
    { sno: 14, tournament: "14th Little League Baseball", date: "31 Jan-02 Feb 2017", winners: "Delhi (Runners-Haryana)", heldAt: "Delhi" }
  ];

  // Sub-Junior National data (complete data)
  const subJuniorData = [
    { sno: 1, tournament: "1st Sub-Junior National", date: "12-15 Feb 1992", boysWinners: "Rajasthan", boysRunners: "Haryana", girlsWinners: "Delhi", girlsRunners: "Tamilnadu", heldAt: "Chandigarh" },
    { sno: 2, tournament: "2nd Sub-Junior National", date: "29 Mar-2 April 1993", boysWinners: "Punjab", boysRunners: "Delhi", girlsWinners: "Delhi", girlsRunners: "Haryana", heldAt: "Karnal" },
    { sno: 3, tournament: "3rd Sub-junior National", date: "1-5 Dec 1993", boysWinners: "Karnataka & Punjab Joint winners", boysRunners: "", girlsWinners: "Orissa & M.P Joint winners", girlsRunners: "", heldAt: "Bangalore" },
    { sno: 4, tournament: "4th Sub-Junior National", date: "30 Mar-3 April 1995", boysWinners: "Maharastra", boysRunners: "Punjab", girlsWinners: "Maharastra", girlsRunners: "Delhi", heldAt: "Rohtak" },
    { sno: 5, tournament: "5th Sub-Junior National", date: "27-31 Mar 1996", boysWinners: "Chandigarh", boysRunners: "M.P.", girlsWinners: "Delhi", girlsRunners: "M.P.", heldAt: "Chandigarh" },
    { sno: 6, tournament: "6th Sub-Junior National", date: "29 Oct-2 Nov.1996", boysWinners: "M.P.", boysRunners: "Haryana", girlsWinners: "Goa", girlsRunners: "M.P.", heldAt: "Rohtak" },
    { sno: 7, tournament: "7th Sub-Junior National", date: "17-21 Oct 1997", boysWinners: "Chandigarh", boysRunners: "M.P.", girlsWinners: "Goa", girlsRunners: "Haryana", heldAt: "Sonepat" },
    { sno: 8, tournament: "8th Sub-Junior National", date: "Mar-1998", boysWinners: "M.P.", boysRunners: "Goa", girlsWinners: "Goa", girlsRunners: "Bihar", heldAt: "Solan" },
    { sno: 9, tournament: "9th Sub-Junior National", date: "9-13 June 1999", boysWinners: "Delhi", boysRunners: "M.P.", girlsWinners: "M.P.", girlsRunners: "Delhi", heldAt: "Cuttack" },
    { sno: 10, tournament: "10th Sub-Junior National", date: "24-28 May 2000", boysWinners: "M.P.", boysRunners: "A.P.", girlsWinners: "Goa", girlsRunners: "Delhi", heldAt: "Solan" },
    { sno: 11, tournament: "11th Sub-Junior National", date: "25-27 May 2001", boysWinners: "Goa", boysRunners: "M.P.", girlsWinners: "Goa", girlsRunners: "Bihar", heldAt: "Solan" },
    { sno: 12, tournament: "12th Sub-Junior National", date: "3-8 May 2002", boysWinners: "Goa", boysRunners: "M.P.", girlsWinners: "Goa", girlsRunners: "M.P.", heldAt: "Goa" },
    { sno: 13, tournament: "13th Sub-Junior National", date: "5-10 May 2003", boysWinners: "M.P.", boysRunners: "A.P.", girlsWinners: "M.P.", girlsRunners: "Chandigarh", heldAt: "Indore" },
    { sno: 14, tournament: "14th Sub-Junior National", date: "24-28 May 2004", boysWinners: "Goa", boysRunners: "Delhi", girlsWinners: "Delhi", girlsRunners: "Goa", heldAt: "Solan" },
    { sno: 15, tournament: "15th Sub-Junior National", date: "13-17 April 2005", boysWinners: "Goa", boysRunners: "Delhi", girlsWinners: "Goa", girlsRunners: "Delhi", heldAt: "Cuttack" },
    { sno: 16, tournament: "16th Sub-Junior National", date: "23-28 May 2006", boysWinners: "Punjab", boysRunners: "Uttaranchal", girlsWinners: "Goa", girlsRunners: "Manipur", heldAt: "Solan" },
    { sno: 17, tournament: "17th Sub-Junior National", date: "22-27 May 2007", boysWinners: "Delhi", boysRunners: "Goa", girlsWinners: "Goa", girlsRunners: "Manipur", heldAt: "Indore (M.P)" },
    { sno: 18, tournament: "18th Sub-Junior National", date: "20-25 May 2008", boysWinners: "Goa", boysRunners: "Orissa", girlsWinners: "Manipur", girlsRunners: "Goa", heldAt: "Imphal" },
    { sno: 19, tournament: "19th Sub-Junior National", date: "02-06 July, 2009", boysWinners: "Delhi", boysRunners: "Orissa", girlsWinners: "Goa", girlsRunners: "Orissa", heldAt: "Solan" },
    { sno: 20, tournament: "20th Sub-Junior National", date: "01-05 May, 2010", boysWinners: "Goa", boysRunners: "Delhi", girlsWinners: "Delhi", girlsRunners: "Goa", heldAt: "Goa" },
    { sno: 21, tournament: "21st Sub-Junior National", date: "21-26 July, 2011", boysWinners: "Joint winner Delhi & Goa", boysRunners: "", girlsWinners: "Joint winner Delhi & Goa", girlsRunners: "", heldAt: "Solan" },
    { sno: 22, tournament: "22nd Sub-Junior National", date: "08-13 May, 2012", boysWinners: "Delhi", boysRunners: "Chhattisgarh / Maharashtra", girlsWinners: "Delhi", girlsRunners: "M. P. / Maharashtra", heldAt: "Bhopal" },
    { sno: 23, tournament: "23rd Sub-Junior National", date: "29-03 Oct 2013", boysWinners: "Delhi", boysRunners: "MAH / CG", girlsWinners: "Manipur", girlsRunners: "MAH / CG", heldAt: "Imphal" },
    { sno: 24, tournament: "24th Sub-Junior National", date: "12-16 May 2015", boysWinners: "MAH", boysRunners: "Orissa / Delhi Chhattisgarh", girlsWinners: "Chhattisgarh", girlsRunners: "Orissa / Delhi", heldAt: "Bhubaneswar" },
    { sno: 25, tournament: "25th Sub-Junior National", date: "24-28 December 2016", boysWinners: "MAH", boysRunners: "Delhi / Orissa", girlsWinners: "Delhi", girlsRunners: "Maharashtra / Goa", heldAt: "Iranjalakuda, Kerala" },
    { sno: 26, tournament: "26th Sub-Junior National", date: "25-30 September 2017", boysWinners: "Delhi", boysRunners: "Chhattisgarh", girlsWinners: "Maharashtra", girlsRunners: "Odisha", heldAt: "Machilipatnam, Krishna District, Andhra Pradesh" },
    { sno: 27, tournament: "27th Sub-Junior National", date: "21-25 September 2018", boysWinners: "Delhi", boysRunners: "2nd Maharashtra 3rd Chandigarh", girlsWinners: "Delhi", girlsRunners: "2nd Chandigarh 3rd Chhattisgarh", heldAt: "Bangad Stadium, Pali Marwar, Rajasthan" },
    { sno: 28, tournament: "28th Sub-Junior National", date: "13-17 july 2019", boysWinners: "Delhi & Chhattisgarh Joint winners", boysRunners: "", girlsWinners: "Delhi", girlsRunners: "Chhattisgarh", heldAt: "Guwahati, Assam" },
    { sno: 29, tournament: "29th Sub-Junior National", date: "08-12 November 2022", boysWinners: "Chandigarh", boysRunners: "Haryana", girlsWinners: "Punjab", girlsRunners: "Andhra Pradesh", heldAt: "Ludhiana, Punjab" }
  ];

  // Junior National data (complete data)
  const juniorNationalData = [
    { sno: 1, tournament: "1st Junior National", date: "15-18 June 1988", boysWinners: "M.P.", boysRunners: "Rajisthan", girlsWinners: "Manipur", girlsRunners: "H.P.", heldAt: "Rohtak" },
    { sno: 2, tournament: "2nd junior National", date: "22-26 May 1989", boysWinners: "A.P.", boysRunners: "Bihar", girlsWinners: "Punjab", girlsRunners: "H.P.", heldAt: "New Delhi" },
    { sno: 3, tournament: "3rd junior National", date: "26-29 Feb 1992", boysWinners: "Haryana", boysRunners: "A.P.", girlsWinners: "Tamilnadu", girlsRunners: "Rajasthan", heldAt: "Chennai" },
    { sno: 4, tournament: "4th Junior National", date: "26-30 Dec 1992", boysWinners: "Haryana", boysRunners: "Rajasthan", girlsWinners: "Haryana", girlsRunners: "Delhi", heldAt: "Chandigarh" },
    { sno: 5, tournament: "5th Junior National", date: "7-11nov 1993", boysWinners: "Haryana", boysRunners: "M.P.", girlsWinners: "Chandigarh", girlsRunners: "Delhi", heldAt: "Ahamedabad" },
    { sno: 6, tournament: "6th Junior National", date: "17-21 Jan 1995", boysWinners: "M.P.", boysRunners: "Punjab", girlsWinners: "M.P.", girlsRunners: "U.P.", heldAt: "Ludhiana" },
    { sno: 7, tournament: "7th Junior National", date: "28-Feb to 3-Mar 1996", boysWinners: "Rajasthan", boysRunners: "Chandigarh", girlsWinners: "Chandigarh", girlsRunners: "Goa", heldAt: "Bharatpur" },
    { sno: 8, tournament: "8th Junior National", date: "29 Mar-2 April 1997", boysWinners: "M.P.", boysRunners: "Haryana", girlsWinners: "M.P.", girlsRunners: "U.P.", heldAt: "Solan" },
    { sno: 9, tournament: "9th Junior National", date: "Feb-1998", boysWinners: "M.P", boysRunners: "-", girlsWinners: "-", girlsRunners: "-", heldAt: "Surat" },
    { sno: 10, tournament: "10th Junior National", date: "11-15 Oct 1998", boysWinners: "Chandigarh", boysRunners: "Delhi", girlsWinners: "M.P.", girlsRunners: "Delhi", heldAt: "Chandigarh" },
    { sno: 11, tournament: "11th Junior National", date: "29sep-3 Oct 1999", boysWinners: "Orrisa", boysRunners: "Punjab", girlsWinners: "M.P", girlsRunners: "Chandigarh", heldAt: "Bhiwani" },
    { sno: 12, tournament: "12th Junior National", date: "18-22 Oct 2000", boysWinners: "Goa", boysRunners: "M.P", girlsWinners: "Goa", girlsRunners: "M.P", heldAt: "Hissar" },
    { sno: 13, tournament: "13th Junior National", date: "16-21 Oct 2001", boysWinners: "M.P", boysRunners: "Goa", girlsWinners: "Delhi", girlsRunners: "Goa", heldAt: "Bhopal" },
    { sno: 14, tournament: "14th Junior National", date: "25 - 29 Nov 2002", boysWinners: "Goa", boysRunners: "Chandigarh", girlsWinners: "Goa", girlsRunners: "M.P.", heldAt: "Chandigarh" },
    { sno: 15, tournament: "15th Junior National", date: "15-20 Jan 2004", boysWinners: "M.P", boysRunners: "Goa", girlsWinners: "Delhi", girlsRunners: "Goa", heldAt: "Chandigarh" },
    { sno: 16, tournament: "16th Junior National", date: "25 - 30 Sep 2004", boysWinners: "Delhi", boysRunners: "Goa", girlsWinners: "Goa", girlsRunners: "M.P.", heldAt: "Bilaspur" },
    { sno: 17, tournament: "17th Junior National", date: "09 - 13 Nov 2005", boysWinners: "Delhi", boysRunners: "Uttranchal", girlsWinners: "Goa", girlsRunners: "M.P.", heldAt: "Ahmedabad" },
    { sno: 18, tournament: "18th Junior National", date: "30Oct - 03 Nov2006", boysWinners: "Goa", boysRunners: "Manipur", girlsWinners: "Goa", girlsRunners: "Punjab", heldAt: "Goa" },
    { sno: 19, tournament: "19th Junior National", date: "28Nov - 02 Dec 2007", boysWinners: "Manipur", boysRunners: "Delhi", girlsWinners: "Manipur", girlsRunners: "Delhi", heldAt: "Cuttack" },
    { sno: 20, tournament: "20th Junior National", date: "14 - 18 Sep 2008", boysWinners: "Orissa", boysRunners: "Delhi", girlsWinners: "Chhattisgarh", girlsRunners: "Delhi", heldAt: "Kolkatta" },
    { sno: 21, tournament: "21st Junior National", date: "08-12 Oct 2009", boysWinners: "Orissa", boysRunners: "Goa", girlsWinners: "Delhi", girlsRunners: "Punjab", heldAt: "Dholpur" },
    { sno: 22, tournament: "22nd Junior National", date: "01-05 Dec. 2010", boysWinners: "Goa", boysRunners: "Chhattisgarh", girlsWinners: "Goa", girlsRunners: "Orissa", heldAt: "Kolkata" },
    { sno: 23, tournament: "23rd Junior National", date: "01-05 Nov 2011", boysWinners: "Delhi", boysRunners: "M.P / Chandigarh", girlsWinners: "Goa", girlsRunners: "Delhi / M.P.", heldAt: "Bhusawal" },
    { sno: 24, tournament: "24th Junior National", date: "22-27 Dec 2012", boysWinners: "Delhi", boysRunners: "Chhattisgarh / Orissa", girlsWinners: "Delhi", girlsRunners: "Goa / Chandigarh", heldAt: "Bhubaneswar" },
    { sno: 25, tournament: "25th Junior National", date: "27-31 Mar 2014", boysWinners: "CH / DL", boysRunners: "UK-OR/JW", girlsWinners: "DL / GA", girlsRunners: "MP-CH/JW", heldAt: "Cuttack" },
    { sno: 26, tournament: "26th Junior National", date: "22-26 Feb 2017", boysWinners: "Maharashtra", boysRunners: "Chandigarh/Punjab", girlsWinners: "Kerala", girlsRunners: "Maharashtra/Punjab", heldAt: "Gudivada, A.P." },
    { sno: 27, tournament: "27th Junior National", date: "07-11 Jan 2018", boysWinners: "Delhi", boysRunners: "Maharashtra 2nd/Gujrat 3rd", girlsWinners: "Delhi", girlsRunners: "Maharashtra 2nd/Punjab 3rd", heldAt: "Disa, Gujrat" },
    { sno: 28, tournament: "28th Junior National", date: "29 March-2 April 2019", boysWinners: "Delhi", boysRunners: "Maharashtra", girlsWinners: "Delhi", girlsRunners: "Maharashtra", heldAt: "Karimnagar, Telangana" },
    { sno: 29, tournament: "29th Junior National", date: "27-31 Jan 2020", boysWinners: "Chhattisgarh", boysRunners: "Delhi", girlsWinners: "Delhi", girlsRunners: "Punjab", heldAt: "Ahmedabad, Gujarat" }
  ];

  // Senior National data (complete data)
  const seniorNationalData = [
    { sno: 1, tournament: "1st Senior National", date: "25-28 Feb 1985", boysWinners: "Delhi", boysRunners: "Punjab", girlsWinners: "Punjab", girlsRunners: "Delhi", heldAt: "Delhi" },
    { sno: 2, tournament: "2nd Senior National", date: "28nov-1dec 1985", boysWinners: "Delhi", boysRunners: "Karnataka", girlsWinners: "A.P.", girlsRunners: "Karnataka", heldAt: "Bangalore" },
    { sno: 3, tournament: "3rd Senior National", date: "23-27 June 1986", boysWinners: "Delhi", boysRunners: "Karnataka", girlsWinners: "A.P.", girlsRunners: "Manipur", heldAt: "Chennai" },
    { sno: 4, tournament: "4th Senior National", date: "16-20 Dec 1987", boysWinners: "Delhi", boysRunners: "Punjab", girlsWinners: "Manipur", girlsRunners: "Punjab", heldAt: "Patna" },
    { sno: 5, tournament: "5th Senior National", date: "4-8 Jan 1989", boysWinners: "Karnataka", boysRunners: "Delhi", girlsWinners: "Karnataka", girlsRunners: "Manipur", heldAt: "Indore" },
    { sno: 6, tournament: "6th Senior National", date: "26-31 Dec 1989", boysWinners: "Delhi", boysRunners: "Karnataka", girlsWinners: "Punjab", girlsRunners: "Karnataka", heldAt: "Jhunjhunu" },
    { sno: 7, tournament: "7th Senior National", date: "2-6 Oct 1991", boysWinners: "A.P.", boysRunners: "Haryana", girlsWinners: "Punjab", girlsRunners: "Tamilnadu", heldAt: "Gargaon" },
    { sno: 8, tournament: "8th Senior National", date: "24-29 May 1992", boysWinners: "Rajasthan& Bihar Joint Winners", boysRunners: "-", girlsWinners: "Manipur", girlsRunners: "Haryana", heldAt: "Patna" },
    { sno: 9, tournament: "9th Senior National", date: "25-29 Dec 1994", boysWinners: "A.P.", boysRunners: "Haryana", girlsWinners: "Karnataka", girlsRunners: "Haryana", heldAt: "Ahmedabad" },
    { sno: 10, tournament: "10th Senior National", date: "15-18 Dec 1995", boysWinners: "-", boysRunners: "-", girlsWinners: "M.P.", girlsRunners: "Goa", heldAt: "Indore" },
    { sno: 11, tournament: "11th Senior National", date: "23-27 June 1995", boysWinners: "M.P.", boysRunners: "A.P.", girlsWinners: "-", girlsRunners: "-", heldAt: "Solan" },
    { sno: 12, tournament: "12th Senior National", date: "31dec-4 Jan 1998", boysWinners: "A.P.", boysRunners: "M.P.", girlsWinners: "M.P.", girlsRunners: "Goa", heldAt: "Indore" },
    { sno: 13, tournament: "13th Senior National", date: "1-5 Feb 1999", boysWinners: "M.P.", boysRunners: "A.P.", girlsWinners: "M.P.", girlsRunners: "Goa", heldAt: "Goa" },
    { sno: 14, tournament: "14th Senior National", date: "13-17 march 2000", boysWinners: "M.P.", boysRunners: "Punjab", girlsWinners: "Chandigarh", girlsRunners: "Goa", heldAt: "Chandigarh" },
    { sno: 15, tournament: "15th Senior National", date: "27-31 Dec 2000", boysWinners: "M.P.", boysRunners: "Haryana", girlsWinners: "M.P.", girlsRunners: "Delhi", heldAt: "Hyderabad" },
    { sno: 16, tournament: "16th Senior National", date: "2-6 Feb 2002", boysWinners: "M.P & Haryana Joint Winners", boysRunners: "-", girlsWinners: "M.P.", girlsRunners: "Manipur", heldAt: "Goa" },
    { sno: 17, tournament: "17th Senior National", date: "5-10 Jan 2003", boysWinners: "Delhi", boysRunners: "Orissa", girlsWinners: "Goa", girlsRunners: "M.P.", heldAt: "Indore" },
    { sno: 18, tournament: "18th Senior National", date: "26-30 March 2004", boysWinners: "M.P.", boysRunners: "Delhi", girlsWinners: "Goa", girlsRunners: "Delhi", heldAt: "Delhi" },
    { sno: 19, tournament: "19th Senior National", date: "21-26 Dec 2004", boysWinners: "Delhi", boysRunners: "Karnataka", girlsWinners: "Goa", girlsRunners: "Karnataka", heldAt: "Chennai" },
    { sno: 20, tournament: "20th Senior National", date: "15-20 Jan 2006", boysWinners: "Goa", boysRunners: "Delhi", girlsWinners: "Goa", girlsRunners: "Delhi", heldAt: "Cuttack" },
    { sno: 21, tournament: "21st Senior National", date: "20-25 Dec 2006", boysWinners: "Goa", boysRunners: "M.P.", girlsWinners: "Goa", girlsRunners: "Delhi", heldAt: "Indore" },
    { sno: 22, tournament: "22nd Senior National", date: "01-05 Nov 2007", boysWinners: "Goa & Punjab Joint Winners", boysRunners: "-", girlsWinners: "Goa", girlsRunners: "Delhi", heldAt: "Navi Mumbai" },
    { sno: 23, tournament: "23rd Senior National", date: "30-Jan to 3-Feb 09", boysWinners: "Goa", boysRunners: "Orissa", girlsWinners: "Delhi", girlsRunners: "Orissa", heldAt: "Cuttack" },
    { sno: 24, tournament: "24th Senior National", date: "12-17 Jan 2010", boysWinners: "Goa", boysRunners: "Delhi/Orissa", girlsWinners: "Manipur", girlsRunners: "Goa/Delhi", heldAt: "Cuttack" },
    { sno: 25, tournament: "25th Senior National", date: "22-27 Nov 2010", boysWinners: "Goa", boysRunners: "Delhi / Orissa", girlsWinners: "Goa", girlsRunners: "Manipur / Punjab", heldAt: "Indore" },
    { sno: 27, tournament: "27th Senior National", date: "25th Feb to 1st Mar 2013", boysWinners: "Haryana", boysRunners: "Delhi/M.P.", girlsWinners: "Maharashtra", girlsRunners: "Delhi/M.P.", heldAt: "Nanded" },
    { sno: 28, tournament: "28th Senior National", date: "28th Nov to 2nd Dec 2013", boysWinners: "Haryana", boysRunners: "Delhi / Punjab", girlsWinners: "Punjab", girlsRunners: "Or/Dl-Goa/JW", heldAt: "Solapur" },
    { sno: 29, tournament: "29th Senior National", date: "12th Jan to 16th Jan 2015", boysWinners: "Goa", boysRunners: "Dl/Haryana-Chan/JW", girlsWinners: "Punjab", girlsRunners: "Chan/Dl-Goa/JW", heldAt: "Madgao" },
    { sno: 30, tournament: "30th Senior National", date: "27-31 Jan 2016", boysWinners: "Delhi / Karnatka", boysRunners: "Chd-Punjab Joint Winners", girlsWinners: "Punjab", girlsRunners: "Maharashtra / Haryana", heldAt: "Belgaum, Karnatka" },
    { sno: 31, tournament: "31st Senior National", date: "26-30 March 2017", boysWinners: "Chandigarh & Haryana Jt. Winners", boysRunners: "Mah-Punjab Joint Winners 3rd place", girlsWinners: "Punjab", girlsRunners: "Odisha / Delhi", heldAt: "Cuttack, Odisha" },
    { sno: 32, tournament: "32nd Senior National", date: "08 - 13 Feb 2018", boysWinners: "Chandigarh", boysRunners: "2nd Punjab, 3rd Haryana", girlsWinners: "Haryana", girlsRunners: "2nd M. P., 3rd Punjab", heldAt: "Bhilai, Chhattisgarh" },
    { sno: 33, tournament: "33rd Senior National", date: "12 - 17 Jan 2019", boysWinners: "Maharashtra", boysRunners: "Delhi", girlsWinners: "Delhi", girlsRunners: "Odisha", heldAt: "Indore, M.P." },
    { sno: 34, tournament: "34th Senior National", date: "29 Mar - 03 Apr 2021", boysWinners: "Telangna", boysRunners: "Delhi", girlsWinners: "Kerala", girlsRunners: "Maharashtra", heldAt: "Nandyal, A.P." },
    { sno: 35, tournament: "35th Senior National", date: "04 - 08 Sep 2022", boysWinners: "Maharashtra", boysRunners: "Punjab", girlsWinners: "Delhi", girlsRunners: "Orissa", heldAt: "Jalandhar, Punjab" }
  ];

  // Federation & Interzonal data (complete data)
  const federationData = [
    { sno: 1, tournament: "1st Federation Cup", date: "30 May - 1 June 1986", mensWinners: "Delhi", mensRunners: "A.P.", womensWinners: "Manipur", womensRunners: "A.P.", heldAt: "Rohtak" },
    { sno: 2, tournament: "2nd Federation Cup", date: "3-7 June 1987", mensWinners: "A.P.", mensRunners: "Karnataka", womensWinners: "Manipur", womensRunners: "A.P.", heldAt: "Simla" },
    { sno: 3, tournament: "1st Interzonal Championship", date: "23-25 Feb 1987", mensWinners: "Northzone", mensRunners: "Southzone", womensWinners: "Northzone", womensRunners: "Southzone", heldAt: "New Delhi" },
    { sno: 4, tournament: "2nd Interzonal Championship", date: "15-17 Jan 1988", mensWinners: "Southzone", mensRunners: "Northzone", womensWinners: "Southzone", womensRunners: "Northzone", heldAt: "Indore" },
    { sno: 5, tournament: "3rd Federation Cup", date: "27-31 Oct 1988", mensWinners: "A.P.", mensRunners: "Delhi", womensWinners: "Manipur", womensRunners: "Punjab", heldAt: "Bharatpur" },
    { sno: 6, tournament: "3rd Interzonal Championship", date: "18-20 Nov 1988", mensWinners: "Southzone", mensRunners: "Northzone", womensWinners: "Eastzone", womensRunners: "Southzone", heldAt: "Mysore" },
    { sno: 7, tournament: "4th Interzonal Championship", date: "29 June - 1 July 1989", mensWinners: "Southzone", mensRunners: "Northzone", womensWinners: "Northzone", womensRunners: "Southzone", heldAt: "Chennai" },
    { sno: 8, tournament: "4th Federation Cup", date: "7-10 June 1990", mensWinners: "A.P.", mensRunners: "Karnataka", womensWinners: "-", womensRunners: "-", heldAt: "Cuttack" },
    { sno: 9, tournament: "5th Interzonal Championship", date: "10-12 Jan 1991", mensWinners: "North Zone", mensRunners: "South Zone", womensWinners: "South Zone", womensRunners: "East Zone", heldAt: "Gandhi Nagar" },
    { sno: 10, tournament: "6th North Zone Chamapionship", date: "12-14 Jan 2002", mensWinners: "Punjab", mensRunners: "Chandigarh", womensWinners: "Punjab", womensRunners: "Chandigarh", heldAt: "Karnal" },
    { sno: 11, tournament: "First Central Zone Championship", date: "16-18 Feb 2002", mensWinners: "Delhi", mensRunners: "U.P.", womensWinners: "Delhi", womensRunners: "U.P.", heldAt: "Noida" },
    { sno: 12, tournament: "4th South Zone Championship", date: "30 Aug to 1 Sep 2002", mensWinners: "Karnataka", mensRunners: "A.P.", womensWinners: "Karnataka", womensRunners: "A.P.", heldAt: "Kumbakonam" },
    { sno: 13, tournament: "East Zone", date: "20 – 22 Feb 2007", mensWinners: "Orissa", mensRunners: "Manipur", womensWinners: "Orissa", womensRunners: "W. Bengal", heldAt: "Cuttack" },
    { sno: 14, tournament: "5th Federation Cup", date: "13 – 15 May 2006", mensWinners: "Goa", mensRunners: "Karnataka", womensWinners: "Goa", womensRunners: "Delhi", heldAt: "Morgau" },
    { sno: 15, tournament: "All India Prize Money Baseball Men Tournament (Cash Award)", date: "20-22 Feb.07", mensWinners: "Goa", mensRunners: "Delhi / Orissa", womensWinners: "-", womensRunners: "-", heldAt: "Cuttack" },
    { sno: 16, tournament: "6th Federation Cup", date: "10-14 Oct 07", mensWinners: "Chandigarh", mensRunners: "Haryana", womensWinners: "Punjab", womensRunners: "Delhi", heldAt: "Abohar" },
    { sno: 17, tournament: "East Zone", date: "5-7 Feb 08", mensWinners: "Orissa", mensRunners: "Bihar", womensWinners: "Manipur", womensRunners: "Orissa", heldAt: "Cuttack" },
    { sno: 18, tournament: "All India (Women) Cash Award Baseball Tournament", date: "5-7 Feb 08", mensWinners: "Manipur", mensRunners: "Goa /Orissa", womensWinners: "-", womensRunners: "-", heldAt: "Cuttack" },
    { sno: 19, tournament: "1st Baseball Championship and cash Award Tournament", date: "29 May to 1 June 2008", mensWinners: "Delhi", mensRunners: "Goa", womensWinners: "Goa", womensRunners: "Orissa", heldAt: "Madurai, Tamil Nadu" },
    { sno: 20, tournament: "South Zone Championship", date: "08-10 May, 2009", mensWinners: "Karnataka", mensRunners: "Kerala/T.N", womensWinners: "Karnataka", womensRunners: "Kerala/T.N", heldAt: "Trivandrum" },
    { sno: 21, tournament: "7th Federation Cup", date: "12-15 July 2009", mensWinners: "Delhi", mensRunners: "Orissa", womensWinners: "Goa", womensRunners: "Orissa", heldAt: "Cuttack" },
    { sno: 22, tournament: "6th East Zone Championship", date: "12-15 July 2009", mensWinners: "Orissa", mensRunners: "Bihar/Manipur", womensWinners: "Orissa", womensRunners: "Manipur", heldAt: "Cuttack" },
    { sno: 23, tournament: "Ist West Zone Championship", date: "01-03 February 2010", mensWinners: "Goa", mensRunners: " Maharashtra/Chhattisgarh", womensWinners: "Goa", womensRunners: "Chhattisgarh/Maharashtra", heldAt: "Madgao, Goa" },
    { sno: 24, tournament: "All India (Men) Cash Award Baseball Tournament", date: "01-03 February 2010", mensWinners: "Delhi", mensRunners: "A.P./Goa", womensWinners: "-", womensRunners: "-", heldAt: "Madgao, Goa" },
    { sno: 25, tournament: "7th North Zone Championship", date: "12-14 March, 2010", mensWinners: "Haryana", mensRunners: "H.P./Chandigarh", womensWinners: "Punjab", womensRunners: "Haryana/H.P.", heldAt: "Rohtak" },
    { sno: 26, tournament: "7th East Zone Championship", date: "24-26 April, 2010", mensWinners: "Orissa", mensRunners: "Manipur/Assam", womensWinners: "Manipur", womensRunners: "Orissa/Assam", heldAt: "Guwahati" },
    { sno: 27, tournament: "2nd Central Zone Championship", date: "28-30 January,2011", mensWinners: "Delhi", mensRunners: "Rajasthan/U.P.", womensWinners: "Delhi", womensRunners: "Rajasthan/U. P.", heldAt: "Garhmukteshwar" },
    { sno: 28, tournament: "2nd West Zone Championship", date: "01-03 May, 2011", mensWinners: "Goa", mensRunners: "Maharashtra/Chhattisgarh", womensWinners: "Goa", womensRunners: "Maharashtra/Chhattisgarh", heldAt: "Daund, Pune" },
    { sno: 29, tournament: "8th North Zone Championship", date: "23-25 March, 2012", mensWinners: "Haryana", mensRunners: "Punjab/Chandigarh", womensWinners: "Haryana", womensRunners: "Punjab/Chandigarh", heldAt: "Faridabad" },
    { sno: 30, tournament: "9th North Zone Championship", date: "01-03 July, 2013", mensWinners: "Punjab", mensRunners: "Chandigarh/J&K", womensWinners: "Punjab", womensRunners: "Chandigarh/J&K", heldAt: "Srinagar" },
    { sno: 31, tournament: "2nd Central Zone Championship", date: "16-18 Feb. 2014", mensWinners: "Rajasthan", mensRunners: "Delhi/U.P.", womensWinners: "Delhi", womensRunners: "UK/Rajasthan", heldAt: "Rajasthan" },
    { sno: 32, tournament: "9th Federation Cup", date: "-", mensWinners: "Delhi", mensRunners: "PB/JW", womensWinners: "PB", womensRunners: "DL", heldAt: "Patiala" },
    { sno: 33, tournament: "10th Federation Cup 24-26 June 2017", date: "24-26 June 2017", mensWinners: "HR", mensRunners: "Punjab/Karnataka", womensWinners: "-", womensRunners: "-", heldAt: "Nakodar" }
  ];

  // International Events data
  const internationalData = [
    { sno: 1, event: "Asian Baseball championship", venue: "Tokyo(Japan)", category: "Senior", year: "1987" },
    { sno: 2, event: "Asian Baseball championship", venue: "Seoul/Korea", category: "Senior", year: "1989" },
    { sno: 3, event: "World Nankyo Boys Baseball championship", venue: "Tokyo(Japan)", category: "Under 11 Years", year: "1990" },
    { sno: 4, event: "1st Asian Cup Baseball Championship", venue: "Manila,Philippines", category: "3rd Position", year: "1995" },
    { sno: 5, event: "2nd Asian Cup Baseball Championship", venue: "Bangkok,Thailand", category: "4th Position", year: "1997" },
    { sno: 6, event: "3rd Asian Cup Baseball Championship", venue: "Chandigarh,India", category: "2nd Position", year: "1999" },
    { sno: 7, event: "'AA' Asian Baseball Championship", venue: "Seoul,Korea", category: "Under 15 Years", year: "2000" },
    { sno: 8, event: "4th 'AAA' Asian Baseball Championship", venue: "Taipei(Taiwan)", category: "Under 17 Years", year: "2001" },
    { sno: 9, event: "World Women Baseball Championship", venue: "Uozu,Japan", category: "Senior", year: "2004" },
    { sno: 10, event: "'A' Asian Baseball Championship", venue: "Chiba,Japan", category: "Under 12 Years", year: "2006" },
    { sno: 11, event: "3rd Women World Cup Baseball", venue: "Matsuyama,Japan", category: "7th Position", year: "2008" },
    { sno: 12, event: "7th BFA \"AA\" ASIAN BASEBALL CHAMPIONSHIP", venue: "CUTTACK, INDIA", category: "4th Position", year: "2012" },
    { sno: 13, event: "12th West Asia Baseball Cup", venue: "Islamabad, Pakistan", category: "3rd Position", year: "2015" },
    { sno: 14, event: "Iran's Presidential Cup", venue: "Tehran, Iran", category: "1st Position", year: "2015" },
    { sno: 15, event: "WBSC Women's Baseball World Cup", venue: "Gijang City, South Korea", category: "11th Position", year: "2016" },
    { sno: 16, event: "1st BFA Women Baseball Championship", venue: "Hong Kong", category: "7th Position", year: "2017" },
    { sno: 17, event: "14th BFA West Asia Cup", venue: "Srilanka, Colombo", category: "3rd Position", year: "2019" },
    { sno: 18, event: "2nd BFA Women Baseball Championship", venue: "China", category: "7th Position", year: "2019" }
  ];

  useEffect(() => {
    document.title = 'Events | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
    
    const cssFiles = [
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
      '/css/screen_layout_mega.css',
      '/css/default.css', 
      '/css/component.css',
      '/css/slimmenu.css'
    ];

    cssFiles.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
      });
    };

    const initializeMenu = async () => {
      try {
        await loadScript('/js/jquery.min.js');
        await loadScript('/js/jquery.slimmenu.js');
        
        setTimeout(() => {
          if (window.$ && typeof window.$.fn.slimmenu === 'function') {
            window.$('ul.slimmenu').slimmenu({
              resizeWidth: '1100',
              collapserTitle: 'Main Menu',
              easingEffect: 'easeInOutQuint',
              animSpeed: 'medium',
              indentChildren: true,
              childrenIndenter: '&raquo;'
            });
          }
        }, 300);
      } catch (error) {
        console.error('Error loading scripts:', error);
      }
    };

    initializeMenu();

    return () => {
      if (window.$ && window.$('ul.slimmenu').length > 0) {
        try {
          window.$('ul.slimmenu').off();
        } catch (e) {}
      }
    };
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        <br /><br />

        {/* Little League Baseball Tournaments */}
        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center><label className="bol">Little League Baseball Tournaments</label></center>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Tournament</th>
                      <th>Date</th>
                      <th>Boys Winners</th>
                      <th>Held at</th>
                    </tr>
                  </thead>
                  <tbody>
                    {littleLeagueData.map((item) => (
                      <tr key={item.sno}>
                        <td>{item.sno}</td>
                        <td>{item.tournament}</td>
                        <td>{item.date}</td>
                        <td>{item.winners}</td>
                        <td>{item.heldAt}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Sub-Junior National Baseball Tournaments */}
        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center><label className="bol">Sub - Junior National Baseball Tournaments</label></center>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Tournament</th>
                      <th>Date</th>
                      <th>Boys Winners</th>
                      <th>Boys Runners</th>
                      <th>Girls Winners</th>
                      <th>Girls Runners</th>
                      <th>Held at</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subJuniorData.map((item) => (
                      <tr key={item.sno}>
                        <td>{item.sno}</td>
                        <td>{item.tournament}</td>
                        <td>{item.date}</td>
                        <td>{item.boysWinners}</td>
                        <td>{item.boysRunners}</td>
                        <td>{item.girlsWinners}</td>
                        <td>{item.girlsRunners}</td>
                        <td>{item.heldAt}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Junior National Baseball Tournaments */}
        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center><label className="bol">Junior National Baseball Tournaments</label></center>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Tournament</th>
                      <th>Date</th>
                      <th>Boys Winners</th>
                      <th>Boys Runners</th>
                      <th>Girls Winners</th>
                      <th>Girls Runners</th>
                      <th>Held at</th>
                    </tr>
                  </thead>
                  <tbody>
                    {juniorNationalData.map((item) => (
                      <tr key={item.sno}>
                        <td>{item.sno}</td>
                        <td>{item.tournament}</td>
                        <td>{item.date}</td>
                        <td>{item.boysWinners}</td>
                        <td>{item.boysRunners}</td>
                        <td>{item.girlsWinners}</td>
                        <td>{item.girlsRunners}</td>
                        <td>{item.heldAt}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Senior National Baseball Tournaments */}
        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center><label className="bol">Senior National Baseball Tournaments</label></center>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Tournament</th>
                      <th>Date</th>
                      <th>Boys Winners</th>
                      <th>Boys Runners</th>
                      <th>Girls Winners</th>
                      <th>Girls Runners</th>
                      <th>Held at</th>
                    </tr>
                  </thead>
                  <tbody>
                    {seniorNationalData.map((item) => (
                      <tr key={item.sno}>
                        <td>{item.sno}</td>
                        <td>{item.tournament}</td>
                        <td>{item.date}</td>
                        <td>{item.boysWinners}</td>
                        <td>{item.boysRunners}</td>
                        <td>{item.girlsWinners}</td>
                        <td>{item.girlsRunners}</td>
                        <td>{item.heldAt}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Federation & Interzonal Baseball Tournaments */}
        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center><label className="bol">Federation & Interzonal Baseball Tournaments</label></center>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Tournament</th>
                      <th>Date</th>
                      <th>Mens Winners</th>
                      <th>Mens Runners</th>
                      <th>Womens Winners</th>
                      <th>Womens Runners</th>
                      <th>Held at</th>
                    </tr>
                  </thead>
                  <tbody>
                    {federationData.map((item) => (
                      <tr key={item.sno}>
                        <td>{item.sno}</td>
                        <td>{item.tournament}</td>
                        <td>{item.date}</td>
                        <td>{item.mensWinners}</td>
                        <td>{item.mensRunners}</td>
                        <td>{item.womensWinners}</td>
                        <td>{item.womensRunners}</td>
                        <td>{item.heldAt}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* International Events */}
        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center><label className="bol">International Events</label></center>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name Of Event</th>
                      <th>Venue</th>
                      <th>Category</th>
                      <th>Year</th>
                    </tr>
                  </thead>
                  <tbody>
                    {internationalData.map((item) => (
                      <tr key={item.sno}>
                        <td>{item.sno}</td>
                        <td>{item.event}</td>
                        <td>{item.venue}</td>
                        <td>{item.category}</td>
                        <td>{item.year}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Events Summary */}
        <div className="col-lg-12">
          <div className="panel panel-info">
            <div className="panel-heading">
              <center><label className="bol">Tournament Summary</label></center>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-2">
                  <div className="well text-center">
                    <h4>Little League</h4>
                    <h2 className="text-primary">14</h2>
                    <p>Tournaments</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="well text-center">
                    <h4>Sub-Junior</h4>
                    <h2 className="text-success">29</h2>
                    <p>Tournaments</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="well text-center">
                    <h4>Junior</h4>
                    <h2 className="text-warning">29</h2>
                    <p>Tournaments</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="well text-center">
                    <h4>Senior</h4>
                    <h2 className="text-info">35</h2>
                    <p>Tournaments</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="well text-center">
                    <h4>Federation</h4>
                    <h2 className="text-default">33</h2>
                    <p>Tournaments</p>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="well text-center">
                    <h4>International</h4>
                    <h2 className="text-danger">18</h2>
                    <p>Events</p>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <p className="lead">
                  The federation has been actively organizing and participating in baseball tournaments since 1985,
                  promoting the sport across different age groups and representing India internationally.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer>
        <div id="outer_main">
          <div id="outer1">
            <div id="aku11">
              <h4 className="link_heading">LOCATION</h4>
              <h4 className="ft">B4/317B, Keshav Puram,<br />Delhi - 110035</h4>
            </div>
            <div id="aku22">
              <h4 className="link_heading">AROUND THE WEB</h4>
              <div id="social">
                <div id="contact_a_dn">
                  <div className="sl sl2"><i className="fa fa-facebook-f" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl3"><i className="fa fa-youtube-play" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl4"><i className="fa fa-twitter" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl5"><i className="fa fa-linkedin" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                </div>
              </div>
            </div>
            <div id="aku33">
              <h4 className="link_heading">CONTACT US</h4>
              <label className="ft">Phone : +918890029024, +919165276531<br />Email: abfi.secretarygeneral@gmail.com</label>
            </div>
          </div>
        </div>
        <div id="main_link">
          <div id="main_link_inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/rules">Rules</a></li>
              <li><a href="/events">Events</a></li>
              <li><a href="/schedule">Schedule</a></li>
              <li><a href="/affiliates">Affiliates</a></li>
              <li><a href="/photo-gallery">Gallery</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
            <ul>
              <li><a href="/international-recognition">International & Recognition</a></li>
              <li><a href="/international-recognition-bfa">International & Recognition BFA</a></li>
              <li><a href="/pdf/voting_rights.pdf" target="_blank">Voting Rights</a></li>
              <li><a href="/registration">Certificate of Registration</a></li>
              <li><a href="/international-participation">International Participation</a></li>
              <li><a href="/pdf/ABFI_constitution.pdf">Constitution</a></li>
              <li><a href="/affiliates">Affiliated Units</a></li>
              <li><a href="#">Firm Name</a></li>
              <li><a href="#">Media Coverage</a></li>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manuals</a></li>
              <li><a href="/history">History</a></li>
              <li><a href="/bearer">Executive Committee</a></li>
              <li><a href="/website-info">Website Info</a></li>
            </ul>
            <div className="text-center">
              <hr />
              <p style={{color: '#fff'}}>For best results use Mozilla or Chrome browsers</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default StaticEventsPage;